import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { RegisterPaymentApiAccountsRequestModel, RegisterPaymentApiAccountsResponseModel } from "@/features/accounts/payment/api/services/register-accounts-model";
import { Timeout } from "@/shared/services/http-client";

export class RegisterPaymentApiAccountsApi {
  /**
   * MoneyLook 口座登録認可開始画面要求（API版）API
   */
  public registerPaymentApiAccounts = async (
    param: RegisterPaymentApiAccountsRequestModel
  ): Promise<RegisterPaymentApiAccountsResponseModel> => {
    const path = `/api/paymentaccounts/api/registeraccounts`;
    const res = await ApiClient.instance.get<RegisterPaymentApiAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
